<template>
  <div id="app">
    <GlobalLoader v-if="!appReady" />

    <div class="app-content" v-else>
      <router-view />

      <SelectStoreModal v-if="appReady && locationStore.showStoreModal" />
      <FooterColonialMarket />
      <CartSidebar />

      <div id="yt-music-player" class="hidden-music"></div>
    </div>
  </div>
</template>

<script>
import CartSidebar from "@/components/CartSidebar.vue";
import GlobalLoader from "@/components/GlobalLoader.vue";
import FooterColonialMarket from "@/components/footer.vue";
import SelectStoreModal from "@/components/SelectStoreModal.vue";
import axios from "axios";
import baseUrl from "@/api";
import { useLocationStore } from "@/stores/location";

export default {
  name: "App",
  components: { 
    CartSidebar, 
    GlobalLoader, 
    FooterColonialMarket, 
    SelectStoreModal
  },
  setup() {
    const locationStore = useLocationStore();
    locationStore.loadFromStorage();
    return { locationStore };
  },
  data() {
    return {
      appReady: false,
      player: null,
      videoId: "-xNSMjHTpg4",
      isPlaying: false,
      isMuted: false
    };
  },

  async mounted() {
    try {
      // 🔥 DETECTAR PAÍS
      const geo = await axios.get("https://ipapi.co/json/");
      const country = geo.data.country_code;

      console.log("País detectado:", country);

      // 🔥 SI ES MÉXICO → REDIRIGIR
      if (country === "MX") {
        window.location.href = "https://tiendasanjudas.com";
        return; // 🚨 IMPORTANTE: detener ejecución
      }

    } catch (e) {
      console.error("Error geolocalización:", e);
    }

    // 🔥 TU LÓGICA ORIGINAL (solo corre si NO es México)
    try {
      const res = await axios.get(`${baseUrl}/shopify/locations`);
      if (res.data?.length > 0 && !this.locationStore.selectedStore) {
        this.locationStore.setStore(res.data[0]);
      }
    } catch (e) { 
      console.error("Error:", e); 
    }

    this.loadYoutubeScript();
    this.appReady = true;
  },

  methods: {
    loadYoutubeScript() {
      window.onYouTubeIframeAPIReady = () => { this.initPlayer(); };
      if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      } else {
        this.initPlayer();
      }
    },

    initPlayer() {
      this.player = new window.YT.Player('yt-music-player', {
        height: '1',
        width: '1',
        videoId: this.videoId,
        playerVars: {
          autoplay: 1,
          loop: 1,
          playlist: this.videoId,
          mute: 1
        },
        events: {
          onReady: (e) => { e.target.playVideo(); }
        }
      });
    },

    activateMagic() {
      if (this.player) {
        this.player.unMute();
        this.player.setVolume(40);
        this.player.playVideo();
        this.isPlaying = true;
      }
    },

    toggleMute() {
      if (this.isMuted) {
        this.player.unMute();
      } else {
        this.player.mute();
      }
      this.isMuted = !this.isMuted;
    }
  }
};
</script>

<style>
.hidden-music {
  position: fixed;
  left: -100px;
  top: -100px;
  width: 1px;
  height: 1px;
  opacity: 0;
}

/* 🎨 BOTÓN */
.music-trigger {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 999;
  background: #000;
  color: #fff;
  border: none;
  padding: 12px 20px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 4px 15px rgba(0,0,0,0.3);
  transition: all 0.3s ease;
}

.music-trigger:hover {
  transform: scale(1.05);
  background: #222;
}

.music-trigger.active {
  padding: 12px;
  width: 45px;
  height: 45px;
  justify-content: center;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .music-trigger {
    bottom: 20px;
    right: 20px;
    padding: 10px 15px;
    font-size: 11px;
  }
}
</style>